<style lang="less" scoped>
    
</style>

<template>
    <div class="list-container">
        <div class="list-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="list-content-div">
            <div class="list-header-title-div">角色管理</div>
            <!-- <ZD-list-querys>
            </ZD-list-querys> -->
            <div class="page-action-btns flex margin-tb-10">
                <button class="common-bg-button" @click="listAddFun()">新 增</button>
                <button class="common-bg-button" @click="listEditFun()">编 辑</button>
                <div class="flex-1"></div>
                <el-input size="small" style="width:320px;margin-right:10px;" class="list-serach-input" v-model="queryInfo.roleName" placeholder="请输入角色名称" clearable></el-input>
                <button class="common-bg-button" @click="getListData(pagination,true)">搜索</button>
            </div>
            <!-- 表格 -->
            <div class="list-table">
                <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData" :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections="(sels)=>{selections=sels}"></ZD-table>
            </div>
            <!-- 分页 -->
            <div class="list-pagination">
                <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageConfig: pageConfig, // 页面配置
                tableData: [], // 表格数据
                selections: [], // 表格选项
                pagination: pageConfig.pagination,
                queryInfo: {}, //页码 搜索内容
                operates: {
					width: 220,
					fixed: "right",
					list: [
						
					]
                }, // 列操作按钮
            }
        },
        methods: {
            init() {
                this.getListData(this.pagination,true);
            },
            // 获取表格数据
            getListData(pagination, reload = false) {
                let _ = this;
                _.$U.showLoading(_);
                _.queryInfo.pageNum = pagination.current - 1;
                if (reload) {
                    this.pagination.current = 1;
                    _.queryInfo.pageNum = 0;
                }
                _.queryInfo.pageSize = pagination.pageSize;
                _.queryInfo.corpNo = _.$store.state.corpNo;
                _.$H.get(_, _.$A.role.list, _.queryInfo).then(res => {
                    _.tableData = res.data.data.content || [];
                    _.pagination.total = res.data.data.totalElements || 0;
                    _.$U.hideLoading(_);
                })
            },
            // 页面新增方法
            listAddFun() {
                this.$S.listAddFun(this, pageConfig.tableEditObj);
            },
            // 页面编辑方法
            listEditFun() {
                this.$S.tableEditFun(this, this.selections, pageConfig.tableEditObj);
            },
        },
        mounted() {
            this.init();
        }
    }
</script>